import { StyleSheet, TextStyle } from 'react-native';
import { Colors, FONT_STACK } from '@shared/styles';

export const fontTextRegular = {
  fontFamily: FONT_STACK,
  fontStyle: 'normal',
  fontWeight: 'normal',
} as TextStyle;

const fontDisplayRegular = {
  fontFamily: FONT_STACK,
  fontStyle: 'normal',
  fontWeight: 'normal',
} as TextStyle;

const fontDisplayBold = {
  fontFamily: FONT_STACK,
  fontWeight: 'bold',
} as TextStyle;

const fontTextSemibold = {
  fontFamily: FONT_STACK,
  fontWeight: '600',
} as TextStyle;

export const MBTypographyStylesRaw = {
  default: {
    color: Colors.v2.purple,
    ...fontTextRegular,
    textRendering: 'geometricPrecision',
  } as TextStyle,
  lineThrough: {
    textDecorationLine: 'line-through',
  } as TextStyle,
  h1: {
    fontSize: 48,
    lineHeight: 53,
    fontFamily: `Maax,${FONT_STACK}`,
    fontWeight: 'bold',
  } as TextStyle,
  h1Mono: {
    fontSize: 48,
    lineHeight: 53,
    letterSpacing: 21,
    fontFamily: 'monospace',
    fontWeight: 'bold',
  } as TextStyle,
  h2: {
    fontSize: 36,
    lineHeight: 43,
    ...fontDisplayRegular,
  } as TextStyle,
  h3: {
    fontSize: 28,
    lineHeight: 33,
    ...fontDisplayRegular,
  } as TextStyle,
  h4: {
    fontSize: 20,
    lineHeight: 30,
    ...fontDisplayBold,
  } as TextStyle,
  h4Semibold: {
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: -0.3,
    ...fontTextSemibold,
  } as TextStyle,
  h4Light: {
    fontSize: 20,
    lineHeight: 30,
    fontWeight: 'normal',
  } as TextStyle,
  subtitle: {
    fontSize: 17,
    lineHeight: 22,
    letterSpacing: -0.3,
    ...fontTextSemibold,
  } as TextStyle,
  body1: {
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: -0.2,
  } as TextStyle,
  body2: {
    fontSize: 14,
    lineHeight: 18,
    letterSpacing: -0.2,
  } as TextStyle,
  overline: {
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: -0.2,
    textTransform: 'uppercase',
  } as TextStyle,
  caption1: {
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: -0.1,
  } as TextStyle,
  caption2: {
    fontSize: 10,
    lineHeight: 13,
    letterSpacing: -0.1,
  } as TextStyle,
};

export const MBTypographyStyles = StyleSheet.create(MBTypographyStylesRaw);
